<template>
  <aside>
    <div>
      <nav class="side-nav">
        <ul>
          <li v-for="item in items" :class="{active: isActive(item)}">
            <router-link :to="{name: 'page', params: {path: item.path || ''}}">
              <i v-if="item.icon" :class="`${item.icon} icon-color-${item.color}`"></i>
              {{ item.title }}
            </router-link>
            <ul v-if="item.items && item.items.length">
              <li v-for="item2 in item.items" :class="{active: isActive(item2)}">
                <router-link :to="{name: 'page', params: {path: item2.path || ''}}">
                  <i v-if="item2.icon" :class="`${item2.icon} icon-color-${item2.color}`"></i>
                  {{ item2.title }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import api from '@/Util/api'
export default {
  data: ()=>({
  }),
  computed: {
    items() {
      return this.stores.nav.items;
    },
  },
  methods: {
    isActive(item) {
      var path=this.$route.params.path || [];
      var activePathType=path[(path.length-1) & ~0x1];
      var activePathId=path[(path.length-1) & ~0x1 | 0x1];
      if ((item.path[0]||"")==activePathType)
        if (!item.path[1] || item.path[1]==activePathId)
          return true;
      for(var subItem of item.items || []) {
        if ((subItem.path[0]||"")==activePathType)
          if (!subItem.path[1] || subItem.path[1]==activePathId)
            return true;
      }
      return false;
    },
    async loadDynamicMenu() {
      var fetchList=[];
      for(var item of this.items) {
        if (item.dynItems) {
          fetchList.push({item, list: api.list(item.dynItems, [["parent", "IS NULL"]])});
        }
      }
      for(var i of fetchList) {
        var rootItems=await i.list;
        i.item.items=rootItems.map(item=>({
          title: item.title,
          icon: i.item.icon,
          path: [i.item.dynItems, item.uuid],
        }));
      }
    }
  },
  mounted() {
    this.loadDynamicMenu();
  },
}
</script>
